import { capitalizeFirstLetter } from "../../lib/utils";

// region Model Selection

const BEST_FAMILY = "opus";
const FALLBACK_FAMILY = "sonnet";

const WARNING_LEVELS = {
  INFO: "info",
  WARNING: "warning",
  ERROR: "error",
};

export function selectPreferredModel(models) {
  const preferred = models.find((m) => m.isPreferred);

  if (preferred?.family === BEST_FAMILY) {
    return { modelId: preferred.id, warning: null };
  }

  if (preferred?.family === FALLBACK_FAMILY) {
    return {
      modelId: preferred.id,
      warning: {
        level: WARNING_LEVELS.WARNING,
        message: `Using ${capitalizeFirstLetter(FALLBACK_FAMILY)} because no ${capitalizeFirstLetter(BEST_FAMILY)} model is available.`,
      },
    };
  }

  // No preferred model — fall back to whatever is available.
  const allNames = models.map((m) => m.name).join(", ");
  return {
    modelId: preferred?.id || models[0]?.id || "",
    warning: {
      level: WARNING_LEVELS.ERROR,
      message: `No ${capitalizeFirstLetter(BEST_FAMILY)} or ${capitalizeFirstLetter(FALLBACK_FAMILY)} models are available. Available models: ${allNames}`,
    },
  };
}

// endregion Model Selection

export function extractSqlResultRows(resultStr) {
  try {
    const parsed =
      typeof resultStr === "string" ? JSON.parse(resultStr) : resultStr;
    if (parsed.success && parsed.data && Array.isArray(parsed.data.rows)) {
      return parsed.data.rows;
    }
    if (Array.isArray(parsed)) {
      return parsed;
    }
    if (parsed.rows && Array.isArray(parsed.rows)) {
      return parsed.rows;
    }
    if (parsed.data && Array.isArray(parsed.data)) {
      return parsed.data;
    }
    return null;
  } catch (err) {
    return null;
  }
}

export function createTurn(query) {
  return {
    query,
    answer: "",
    sqlQueries: [],
    thinkingText: "",
    thinkingExpanded: true,
    activeTab: "answer",
    metrics: null,
    conversationId: null,
    feedback: null,
  };
}
